import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { BadgeModule } from '@coreui/angular-pro';
import { MbscModule } from '@mobiscroll/angular';

@Component({
  selector: 'app-event-view-notifications',
  imports: [MbscModule, CommonModule, BadgeModule],
  templateUrl: './event-view-notifications.component.html',
  styleUrl: './event-view-notifications.component.scss'
})
export class EventViewNotificationsComponent {
  @Input() event!:any;

  errorLabels: Record<string, string> = {
  ERROR_VBMATERIAL_MISSING: 'VB',
  ERROR_VBMATERIAL_LINK_INVALID: 'VB',
  ERROR_TICKETNO: 'Ticket',
  ADDRESS_MISSING: 'Adresse',
  ADDRESS_INVALID_FORMAT: 'Adresse',
  ONLINE_LINK_MISSING: 'Link',
  ONLINE_LINK_INVALID: 'Link',
  ERROR_INTERPRETER: 'Dolmetscher',
  ERROR_STATUS: 'Status',
  ERROR_BACKLOG: 'Backlog',
};

getErrorLabel(code: string): string {
  return this.errorLabels[code] ?? code;
}
}
